import { render } from "./NotFoundPage.vue?vue&type=template&id=3ba85584&scoped=true"
const script = {}

import "./NotFoundPage.vue?vue&type=style&index=0&id=3ba85584&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ba85584"]])

export default __exports__